/**
 * ============================================================================
 * File: themes/generatepress-child/src/responsive-media/frontend.js
 * ----------------------------------------------------------------------------
 * Frontend-Logik des Responsive-Media-Blocks.
 * ============================================================================
 */

document.addEventListener('DOMContentLoaded', () => {

    /* Alle Responsive-Media-Blöcke initialisieren */
    document
        .querySelectorAll('.wp-block-gb-responsive-media')
        .forEach(block => {

            /* Post-ID aus Gutenberg-Block auslesen */
            const postId = block.dataset.postId;

            /* Post-Typ aus Gutenberg-Block auslesen */
            const postType = block.dataset.postType;

            if (!postId) {
                return;
            }

            if (postType === 'page') {
                initOutputMedia(postId, 'page');
            }

            if (postType === 'post') {
                initOutputMedia(postId, 'post');
            }

            if (postType === 'recipe') {
                initOutputMedia(postId, 'recipe');
            }

        });

});